




































import { Component, Vue } from "vue-property-decorator";
import { getId, getRouteName } from '@/config/cookies'
import { bandCar } from '@/api/interface'
import { bandCarInfo } from '@/api/car'
import { telPattern, truckPattern } from '@/config'
import { compress, ratios } from '@/config/utils'
@Component
export default class extends Vue {
    private generalRules: Array<object> = [{required: true, message: '请输入正确内容'  }]
	private telNumber: Array<object> = [{ pattern:telPattern, message: '请输入正确手机号'}]
	private truckNumber: Array<object> = [{ pattern:truckPattern, message: '请输入正确车牌号'}]
    private form: bandCar = {
		openId: '',
		drivingNumber: '',
		plateNumber: '',
		contact: '',
		telNumber: '',
		transNumber: '',
		driver_pos_url: '', 
		driver_neg_url: ''
    }
	private async getPhotosFront(file: any) {
		(this.$refs.frontPhotos as any).src = file.content	
		let ratio = ratios(file.file.size)
	  	let str = await compress(file.content, ratio)
		this.form.driver_pos_url = str
	}
    private async getPhotosVerso(file: any) {
	  (this.$refs.versoPhotos as any).src = file.content	
	  let ratio = ratios(file.file.size)
	  let str = await compress(file.content, ratio)
	  this.form.driver_neg_url = str
    }
    
    private async onSubmit() {
		if(!this.form.driver_pos_url) {
			this.$notify({ type: "danger", message: "请上传行驶证主页"});
			return
		}
		if(!this.form.driver_neg_url) {
			this.$notify({ type: "danger", message: "请上传行驶证副页"});
			return
		}
		let res: any = await bandCarInfo(this.form)
		if(res.status == '1') {
			this.$notify({ type: "success", message: "绑定车辆成功" });
			// if(getRouteName()) this.$router.replace({name: getRouteName()})
		}else{
			this.$notify({ type: "danger", message: res.info });
		}
	}
	private mounted() {
		this.form.openId = getId()
	}
}
